export class Message {
}